import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, ArrowRight } from 'lucide-react';

/**
 * Card visual con la información del autor que aparece al final
 * de cada artículo del blog.
 * Mejora E-E-A-T (Experience-Expertise-Authoritativeness-Trust).
 */
export default function AuthorBox({ author }) {
  if (!author) return null;

  return (
    <div
      className="mt-12 pt-8 border-t border-slate-800"
      data-testid="author-box"
    >
      <div className="bg-gradient-to-br from-slate-900 to-slate-900/40 border border-slate-800 rounded-2xl p-6 md:p-8">
        <p className="text-xs uppercase tracking-widest text-emerald-400 font-semibold mb-4">
          Sobre el autor
        </p>
        <div className="flex flex-col sm:flex-row gap-5">
          {/* Foto */}
          <Link to={`/autor/${author.slug}`} className="flex-shrink-0">
            <img
              src={author.image}
              alt={author.name}
              className="w-20 h-20 sm:w-24 sm:h-24 rounded-xl object-cover border border-slate-800 hover:border-emerald-500/50 transition-colors"
              data-testid="author-box-image"
            />
          </Link>
          {/* Texto */}
          <div className="flex-1 min-w-0">
            <Link
              to={`/autor/${author.slug}`}
              className="inline-block group"
              data-testid="author-box-name-link"
            >
              <h4 className="text-lg sm:text-xl font-bold text-slate-50 group-hover:text-emerald-400 transition-colors">
                {author.name}
              </h4>
              <p className="text-xs text-slate-500">{author.role}</p>
            </Link>
            <p className="text-sm text-slate-300 mt-3 leading-relaxed">
              {author.bio}
            </p>
            <div className="flex flex-wrap items-center gap-4 mt-4">
              <Link
                to={`/autor/${author.slug}`}
                className="inline-flex items-center gap-1 text-sm text-emerald-400 hover:text-emerald-300 font-medium transition-colors"
                data-testid="author-box-profile-link"
              >
                Ver perfil <ArrowRight className="w-3.5 h-3.5" />
              </Link>
              {author.linkedin && (
                <a
                  href={author.linkedin}
                  target="_blank"
                  rel="noopener noreferrer me"
                  className="inline-flex items-center gap-1 text-sm text-blue-400 hover:text-blue-300 transition-colors"
                  data-testid="author-box-linkedin"
                >
                  <Linkedin className="w-3.5 h-3.5" /> LinkedIn
                </a>
              )}
              {author.email && (
                <a
                  href={`mailto:${author.email}`}
                  className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-slate-300 transition-colors"
                  data-testid="author-box-email"
                >
                  <Mail className="w-3.5 h-3.5" /> Contacto
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
